var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: "Cost Trends" } }, [
    _c(
      "div",
      { staticClass: "flex flex-col w-full px-2 py-4 relative" },
      [
        _c("VueLoading", {
          attrs: { active: _vm.loading, "is-full-page": false },
          on: {
            "update:active": function($event) {
              _vm.loading = $event
            }
          }
        }),
        _vm._v(" "),
        _vm.metrics.length > 0
          ? _c("CostsMetricsGraph", {
              key: _vm.id,
              attrs: {
                metrics: _vm.metrics,
                name: "test",
                id: _vm.id,
                activeType: _vm.activeType
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "text-center text-sm text-gray-500 mt-4" }, [
          _vm._v("[Insert AI breakdown here]")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91cf979a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91cf979a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/GraphCards/CostGraphCard.vue
// module id = null
// module chunks = 